import { SUPPORTED_REGIONS } from '../../../shared/enums';

export const HERO_REGION_KEYS = {
  US: 'US',
  CA: 'CA',
  AU: 'AU',
  DEFAULT: 'DEFAULT',
};

export const resolveHeroRegionKey = region => {
  switch (region) {
  case SUPPORTED_REGIONS.US:
    return HERO_REGION_KEYS.US;
  case SUPPORTED_REGIONS.CA:
    return HERO_REGION_KEYS.CA;
  case SUPPORTED_REGIONS.AU:
    return HERO_REGION_KEYS.AU;
  default:
    return HERO_REGION_KEYS.DEFAULT;
  }
};

export const buildHeroPreloadLinks = ({
  desktop,
  mobile,
  type,
  responsiveWidth,
}) => [
  {
    rel: 'preload',
    as: 'image',
    href: desktop,
    type,
    media: `(min-width: ${responsiveWidth + 1}px)`,
    fetchpriority: 'high',
  },
  {
    rel: 'preload',
    as: 'image',
    href: mobile,
    type,
    media: `(max-width: ${responsiveWidth}px)`,
    fetchpriority: 'high',
  },
];
